import React, { Component } from "react"
import PropTypes from "prop-types"
import { connect } from "react-redux"
import { change, Field, reduxForm } from "redux-form"
import { isEqual } from "lodash"

import styles from "../Search.css"

let invalidTrackingNumber = false

class SearchForm extends Component {
  static propTypes = {
    changeForm: PropTypes.func.isRequired,
    search: PropTypes.string,
    onSubmit: PropTypes.func.isRequired,
    pristine: PropTypes.bool.isRequired,
    submitting: PropTypes.bool.isRequired,
  }
  static defaultProps = {
    search: "",
  }
  static contextTypes = {
    t: PropTypes.func.isRequired,
  }

  componentDidMount() {
    const { changeForm, search } = this.props

    changeForm("search", "search", search)
  }

  componentWillUpdate(nextProps) {
    const { changeForm, search } = this.props

    if (!isEqual(nextProps.search, search)) {
      changeForm("search", "search", nextProps.search)
    }
  }

  error(value) {
    const searchRegExp = /^[a-zA-Z\d\s]{0,20}$|^[a-zA-Z\d\s]{1,20}(,{1}[a-zA-Z\d\s]{0,20}[a-zA-Z\d]{1}\s?)*,?\s?$/

    invalidTrackingNumber = searchRegExp.test(value) ? undefined : "invalid tracking number"
    return invalidTrackingNumber
  }

  renderInput({ input, label, placeholder, info, type, meta: { error } }) {
    return (
      <div className={[styles.field, invalidTrackingNumber ? styles.error : ""].join(" ")}>
        <input {...input} placeholder={placeholder} type={type} />
        {(error && <span className={styles.error}>{label}</span>)}
        {(!error && info && (
          <span className="hidden-xs nowrap fs-12">
            * {info}
          </span>
        ))}
      </div>
    )
  }

  render() {
    const { onSubmit, pristine, submitting } = this.props
    const { t: translate } = this.context

    return (
      <form className={styles.form} onSubmit={onSubmit}>
        <div className={styles.group}>
          <Field
            name="search"
            component={this.renderInput}
            type="text"
            label={translate("Invalid tracking number")}
            placeholder={translate("Enter your tracking number(s)")}
            info={translate("You can check the status of multiple parcels. Separate parcel numbers with comma.")}
            validate={this.error}
          />
          <button
            className={styles.submit}
            type="submit"
            disabled={pristine || submitting || invalidTrackingNumber}
          >
            <i className="zmdi zmdi-search"></i>
          </button>
        </div>
      </form>
    )
  }
}

const form = "search"

const mapDispatchToProps = dispatch => ({
  changeForm: (name, field, value) => dispatch(change(name, field, value)),
})

SearchForm = connect(null, mapDispatchToProps)(SearchForm)

export default reduxForm({
  form,
})(SearchForm)



// WEBPACK FOOTER //
// ./src/shared/components/Search/SearchForm/SearchForm.js